import Seo from "@/components/Seo";
import Hero from "@/components/home/Hero";
import TrustStrip from "@/components/home/TrustStrip";
import FeaturedProducts from "@/components/home/FeaturedProducts";
import { WhySection, QualitySection } from "@/components/home/WhyQuality";
import { FarmerSection, DistributorSection } from "@/components/home/FarmerDistributor";
import { FaqSection, FinalCta } from "@/components/home/FaqCta";
import { Marquee } from "@/components/motion";

const MARQUEE_ITEMS = ["MAIZE", "WHEAT", "SIPRA 6655", "SIPRA 8165", "SIYA 303", "BIHAR", "25 KG PACKS", "FARMER FIRST"];

export default function Home() {
  return (
    <>
      <Seo
        title="ICROPSIA India Pvt Ltd — Premium Maize & Wheat Seeds in Bihar"
        description="Quality-focused maize and wheat seeds — Sipra 6655, Sipra 8165 and Siya 303 — in professional branded packaging for farmers, dealers and distributors across Bihar."
      />
      <Hero />
      <TrustStrip />
      <Marquee items={MARQUEE_ITEMS} />
      <FeaturedProducts />
      <WhySection />
      <QualitySection />
      <FarmerSection />
      <DistributorSection />
      <FaqSection />
      <FinalCta />
    </>
  );
}
